export const test = [
  {
    key: '1',
    No: '1',
    title: '6-5 중간고사 02',
    date: '2020-09-01',
    number: "T-00310202",
    total: "16/16",
    status: "완료",
    pdf:"/test.pdf"
  },
  {
    key: '2',
    No: '2',
    title: '[2회]KNN수학창의력대회 선다형서술형문제(초등4학년)',
    date: '2020-09-01',
    number: "MATH-2-1",
    total: "12/16",
    status: "진행 중",
    pdf:"https://cdn.cloubot.com/class-boom/7dbad2bf-cb73-4cae-9ea2-3878f9acf862[2회]KNN수학창의력대회 정답(전학년).pdf"
  },
  {
    key: '3',
    No: '3',
    title: '[2회]KNN수학창의력대회 정답(전학년)',
    date: '2020-09-01',
    number: "MATH-2-2",
    total: "12/16",
    status: "진행 중",
    pdf:"https://cdn.cloubot.com/class-boom/7dbad2bf-cb73-4cae-9ea2-3878f9acf862[2회]KNN수학창의력대회 정답(전학년).pdf"
  },
  {
    key: '4',
    No: '4',
    title: '[3회]KNN수학창의력대회 서술형문제(초등4학년)',
    date: '2020-09-01',
    number: "MATH-3-1",
    total: "16/16",
    status: "완료",
    pdf:"https://cdn.cloubot.com/class-boom/143e3980-466b-4a34-9ed0-87a400dc9fd6[2회]KNN수학창의력대회 선다형서술형문제(초등4학년).pdf"
  },
  {
    key: '5',
    No: '5',
    title: '[3회]KNN수학창의력대회 선다형문제(초등4학년)',
    date: '2020-09-01',
    number: "MATH-3-2",
    total: "16/16",
    status: "완료",
    pdf:"https://cdn.cloubot.com/class-boom/766bf8b9-e221-4720-aa94-87ac1b3641fb[3회]KNN수학창의력대회 선다형문제(초등4학년).pdf"
  },
  {
    key: '6',
    No: '6',
    title: '[3회]KNN수학창의력대회 정답(전학년)',
    date: '2020-09-01',
    number: "MATH-3-3",
    total: "16/16",
    status: "완료",
    pdf:"https://cdn.cloubot.com/class-boom/d4204c18-4749-4da9-8517-997cc343073d[3회]KNN수학창의력대회 정답(전학년).pdf"
  },
  {
    key: '7',
    No: '7',
    title: '[4회]KNN수학창의력대회 서술형문제(초등4학년)',
    date: '2020-09-01',
    number: "MATH-3-4",
    total: "16/16",
    status: "완료",
    pdf:"https://cdn.cloubot.com/class-boom/73d05690-6845-4971-8355-3f7d6fe0a07a[4회]KNN수학창의력대회 서술형문제(초등4학년).pdf"
  },
  {
    key: '8',
    No: '8',
    title: '[4회]KNN수학창의력대회 선다형문제(초등4학년)',
    date: '2020-09-01',
    number: "MATH-4-1",
    total: "16/16",
    status: "완료",
    pdf:"https://cdn.cloubot.com/class-boom/9fd9b7a7-884a-48fb-88bb-7f9dc3792e0d[4회]KNN수학창의력대회 선다형문제(초등4학년).pdf"
  },
  {
    key: '9',
    No: '9',
    title: '[4회]KNN수학창의력대회 정답(전학년)',
    date: '2020-09-01',
    number: "MATH-4-1",
    total: "16/16",
    status: "완료",
    pdf:"https://cdn.cloubot.com/class-boom/c45e6064-f937-42c5-9e5c-6eae044c17e7[4회]KNN수학창의력대회 정답(전학년).pdf"
  },
  {
    key: '10',
    No: '10',
    title: '[5회]KNN수학창의력대회 선다형서술형문제(초등4학년)',
    date: '2020-09-01',
    number: "MATH-5-1",
    total: "12/16",
    status: "진행 중",
    pdf:"https://cdn.cloubot.com/class-boom/a57e458d-40e0-4eb2-8ea7-57a4dab2c64f[5회]KNN수학창의력대회 선다형서술형문제(초등4학년).pdf"
  },
  {
    key: '11',
    No: '11',
    title: '[5회]KNN수학창의력대회 정답(4학년)',
    date: '2020-09-01',
    number: "MATH-5-2",
    total: "12/16",
    status: "진행 중",
    pdf:"https://cdn.cloubot.com/class-boom/705c1fcc-9292-4f06-9285-07f03ade5d79[5회]KNN수학창의력대회 정답(4학년).pdf"
  },
  {
    key: '12',
    No: '12',
    title: '[6회]KNN수학창의력대회 서술형문제(초등4학년)',
    date: '2020-09-01',
    number: "MATH-6-1",
    total: "16/16",
    status: "완료",
    pdf:"https://cdn.cloubot.com/class-boom/ad252c5e-e61a-41c4-829c-0cfd972a6cce[6회]KNN수학창의력대회 정답(초등3-4학년).pdf"
  },
];

export const testFiles = {"data":{"assignedTestUserSingle":{"idx":39,"status":1,"score":null,"idate":null,"start_time":null,"end_time":null,"assigned_tests":{"idx":20,"title":"English 1","start_time":"2021-01-30T03:32:26.000Z","limit_time":60,"tests":{"idx":64,"title":"Awesome_0121_001","code":"T-2101211001","main_pdf":{"path":"https://cdn.cloubot.com/class-boom/b9b22f38-a771-4f22-a6ff-2fcd3d90ecb0Awesome_Monthly Test_Level3_Vol1_032819.pdf","name":"Awesome_Monthly Test_Level3_Vol1_032819.pdf","__typename":"Files"},"extra_pdf":{"idx":56,"name":"Awesome_Monthly Test_Level1_Vol1_Answer_Key_032819.pdf","path":"https://cdn.cloubot.com/class-boom/0d88c2bc-9f0c-438a-b91c-0bac675377d0Awesome_Monthly Test_Level1_Vol1_Answer_Key_032819.pdf","mime_type":"application/pdf","encoding":"7bit","is_public":false,"storage_type":1,"folders":{"idx":8,"name":"Awesome","idate":"2021-01-05T16:43:36.000Z","user":{"idx":1000002,"name":"Test Campus","__typename":"User"},"__typename":"Folders"},"user":{"idx":1000002,"name":"Test Campus","__typename":"User"},"videos":null,"idate":"2021-01-05T16:58:39.000Z","__typename":"Files"},"extra_audio":null,"extra_video":{"idx":122,"name":"GMT20201126-024457_Class-1_1920x1200 (1).mp4","path":"/videos/500729601","mime_type":"video/vimeo","encoding":"vimeo","is_public":false,"storage_type":2,"folders":{"idx":2,"name":"학원 콘텐츠","idate":"2020-12-09T09:57:52.000Z","user":null,"__typename":"Folders"},"user":{"idx":1000002,"name":"Test Campus","__typename":"User"},"videos":{"idx":63,"title":"GMT20201126-024457_Class-1_1920x1200 (1).mp4","video_id":"/videos/500729601","data":"{\"uri\":\"/videos/500729601\",\"name\":\"GMT20201126-024457_Class-1_1920x1200 (1).mp4\",\"description\":null,\"type\":\"video\",\"link\":\"https://vimeo.com/500729601\",\"duration\":0,\"width\":400,\"language\":null,\"height\":300,\"embed\":{\"buttons\":{\"like\":true,\"watchlater\":true,\"share\":true,\"embed\":true,\"hd\":false,\"fullscreen\":true,\"scaling\":true},\"logos\":{\"vimeo\":true,\"custom\":{\"active\":false,\"url\":null,\"link\":null,\"sticky\":false}},\"title\":{\"name\":\"user\",\"owner\":\"user\",\"portrait\":\"user\"},\"playbar\":true,\"volume\":true,\"speed\":false,\"color\":\"00adef\",\"uri\":null,\"html\":\"<iframe src=\\\"https://player.vimeo.com/video/500729601?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=159657\\\" width=\\\"400\\\" height=\\\"300\\\" frameborder=\\\"0\\\" allow=\\\"autoplay; fullscreen; picture-in-picture\\\" allowfullscreen title=\\\"GMT20201126-024457_Class-1_1920x1200 (1).mp4\\\"></iframe>\",\"badges\":{\"hdr\":false,\"live\":{\"streaming\":false,\"archived\":false},\"staff_pick\":{\"normal\":false,\"best_of_the_month\":false,\"best_of_the_year\":false,\"premiere\":false},\"vod\":false,\"weekend_challenge\":false}},\"created_time\":\"2021-01-15T05:34:27+00:00\",\"modified_time\":\"2021-01-15T05:34:27+00:00\",\"release_time\":\"2021-01-15T05:34:27+00:00\",\"content_rating\":[\"unrated\"],\"license\":null,\"privacy\":{\"view\":\"anybody\",\"embed\":\"public\",\"download\":false,\"add\":true,\"comments\":\"anybody\"},\"pictures\":{\"uri\":null,\"active\":false,\"type\":\"default\",\"sizes\":[{\"width\":100,\"height\":75,\"link\":\"https://i.vimeocdn.com/video/default_100x75?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_100x75&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":200,\"height\":150,\"link\":\"https://i.vimeocdn.com/video/default_200x150?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_200x150&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":295,\"height\":166,\"link\":\"https://i.vimeocdn.com/video/default_295x166?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_295x166&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":640,\"height\":360,\"link\":\"https://i.vimeocdn.com/video/default_640x360?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_640x360&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":640,\"height\":480,\"link\":\"https://i.vimeocdn.com/video/default_640x480?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_640x480&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":1280,\"height\":720,\"link\":\"https://i.vimeocdn.com/video/default_1280x720?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_1280x720&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":960,\"height\":720,\"link\":\"https://i.vimeocdn.com/video/default_960x720?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_960x720&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":1280,\"height\":960,\"link\":\"https://i.vimeocdn.com/video/default_1280x960?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_1280x960&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":1920,\"height\":1080,\"link\":\"https://i.vimeocdn.com/video/default_1920x1080?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_1920x1080&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"},{\"width\":1920,\"height\":1440,\"link\":\"https://i.vimeocdn.com/video/default_1920x1440?r=pad\",\"link_with_play_button\":\"https://i.vimeocdn.com/filter/overlay?src0=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2Fdefault_1920x1440&src1=http%3A%2F%2Ff.vimeocdn.com%2Fp%2Fimages%2Fcrawler_play.png\"}],\"resource_key\":\"7a491d0e8cad256a8ac2fd6d207e647c1b034bad\",\"default_picture\":true},\"tags\":[],\"stats\":{\"plays\":0},\"categories\":[],\"metadata\":{\"connections\":{\"comments\":{\"uri\":\"/videos/500729601/comments\",\"options\":[\"GET\",\"POST\"],\"total\":0},\"credits\":{\"uri\":\"/videos/500729601/credits\",\"options\":[\"GET\",\"POST\"],\"total\":0},\"likes\":{\"uri\":\"/videos/500729601/likes\",\"options\":[\"GET\"],\"total\":0},\"pictures\":{\"uri\":\"/videos/500729601/pictures\",\"options\":[\"GET\",\"POST\"],\"total\":0},\"texttracks\":{\"uri\":\"/videos/500729601/texttracks\",\"options\":[\"GET\",\"POST\"],\"total\":0},\"related\":null,\"recommendations\":{\"uri\":\"/videos/500729601/recommendations\",\"options\":[\"GET\"]},\"albums\":{\"uri\":\"/videos/500729601/albums\",\"options\":[\"GET\",\"PATCH\"],\"total\":0},\"available_albums\":{\"uri\":\"/videos/500729601/available_albums\",\"options\":[\"GET\"],\"total\":0},\"available_channels\":{\"uri\":\"/videos/500729601/available_channels\",\"options\":[\"GET\"],\"total\":0},\"versions\":{\"uri\":\"/videos/500729601/versions\",\"options\":[\"GET\"],\"total\":1}},\"interactions\":{\"watchlater\":{\"uri\":\"/users/104937606/watchlater/500729601\",\"options\":[\"GET\",\"PUT\",\"DELETE\"],\"added\":false,\"added_time\":null},\"report\":{\"uri\":\"/videos/500729601/report\",\"options\":[\"POST\"],\"reason\":[\"pornographic\",\"harassment\",\"ripoff\",\"incorrect rating\",\"spam\",\"causes harm\",\"csam\"]},\"view_team_members\":{\"uri\":\"/videos/500729601/teammembers\",\"options\":[\"GET\"]},\"edit\":{\"uri\":\"/videos/500729601\",\"options\":[\"PATCH\"]},\"delete\":{\"uri\":\"/videos/500729601\",\"options\":[\"DELETE\"]}}},\"user\":{\"uri\":\"/users/104937606\",\"name\":\"클라우봇개발팀\",\"link\":\"https://vimeo.com/user104937606\",\"location\":\"\",\"gender\":\"\",\"bio\":null,\"short_bio\":null,\"created_time\":\"2019-11-08T00:14:52+00:00\",\"pictures\":{\"uri\":\"/users/104937606/pictures/34877671\",\"active\":true,\"type\":\"custom\",\"sizes\":[{\"width\":30,\"height\":30,\"link\":\"https://i.vimeocdn.com/portrait/34877671_30x30\"},{\"width\":72,\"height\":72,\"link\":\"https://i.vimeocdn.com/portrait/34877671_72x72\"},{\"width\":75,\"height\":75,\"link\":\"https://i.vimeocdn.com/portrait/34877671_75x75\"},{\"width\":100,\"height\":100,\"link\":\"https://i.vimeocdn.com/portrait/34877671_100x100\"},{\"width\":144,\"height\":144,\"link\":\"https://i.vimeocdn.com/portrait/34877671_144x144\"},{\"width\":216,\"height\":216,\"link\":\"https://i.vimeocdn.com/portrait/34877671_216x216\"},{\"width\":288,\"height\":288,\"link\":\"https://i.vimeocdn.com/portrait/34877671_288x288\"},{\"width\":300,\"height\":300,\"link\":\"https://i.vimeocdn.com/portrait/34877671_300x300\"},{\"width\":360,\"height\":360,\"link\":\"https://i.vimeocdn.com/portrait/34877671_360x360\"}],\"resource_key\":\"525a63a36ac8556a17e8c4e5e5a84323d8189116\",\"default_picture\":false},\"websites\":[],\"metadata\":{\"connections\":{\"albums\":{\"uri\":\"/users/104937606/albums\",\"options\":[\"GET\"],\"total\":0},\"appearances\":{\"uri\":\"/users/104937606/appearances\",\"options\":[\"GET\"],\"total\":0},\"categories\":{\"uri\":\"/users/104937606/categories\",\"options\":[\"GET\"],\"total\":0},\"channels\":{\"uri\":\"/users/104937606/channels\",\"options\":[\"GET\"],\"total\":0},\"feed\":{\"uri\":\"/users/104937606/feed\",\"options\":[\"GET\"]},\"followers\":{\"uri\":\"/users/104937606/followers\",\"options\":[\"GET\"],\"total\":0},\"following\":{\"uri\":\"/users/104937606/following\",\"options\":[\"GET\"],\"total\":0},\"groups\":{\"uri\":\"/users/104937606/groups\",\"options\":[\"GET\"],\"total\":0},\"likes\":{\"uri\":\"/users/104937606/likes\",\"options\":[\"GET\"],\"total\":0},\"membership\":{\"uri\":\"/users/104937606/membership/\",\"options\":[\"PATCH\"]},\"moderated_channels\":{\"uri\":\"/users/104937606/channels?filter=moderated\",\"options\":[\"GET\"],\"total\":0},\"portfolios\":{\"uri\":\"/users/104937606/portfolios\",\"options\":[\"GET\"],\"total\":0},\"videos\":{\"uri\":\"/users/104937606/videos\",\"options\":[\"GET\"],\"total\":145},\"watchlater\":{\"uri\":\"/users/104937606/watchlater\",\"options\":[\"GET\"],\"total\":0},\"shared\":{\"uri\":\"/users/104937606/shared/videos\",\"options\":[\"GET\"],\"total\":0},\"pictures\":{\"uri\":\"/users/104937606/pictures\",\"options\":[\"GET\",\"POST\"],\"total\":1},\"watched_videos\":{\"uri\":\"/me/watched/videos\",\"options\":[\"GET\"],\"total\":0},\"folders_root\":{\"uri\":\"/users/104937606/folders/root\",\"options\":[\"GET\"]},\"folders\":{\"uri\":\"/users/104937606/folders\",\"options\":[\"GET\",\"POST\"],\"total\":4},\"teams\":{\"uri\":\"/users/104937606/teams\",\"options\":[\"GET\"],\"total\":1},\"block\":{\"uri\":\"/me/block\",\"options\":[\"GET\"],\"total\":0}}},\"location_details\":{\"formatted_address\":\"\",\"latitude\":null,\"longitude\":null,\"city\":null,\"state\":null,\"neighborhood\":null,\"sub_locality\":null,\"state_iso_code\":null,\"country\":null,\"country_iso_code\":null},\"skills\":[],\"available_for_hire\":false,\"can_work_remotely\":false,\"preferences\":{\"videos\":{\"privacy\":{\"view\":\"anybody\",\"comments\":\"anybody\",\"embed\":\"whitelist\",\"download\":false,\"add\":true}}},\"content_filter\":[\"language\",\"drugs\",\"violence\",\"nudity\",\"safe\",\"unrated\"],\"upload_quota\":{\"space\":{\"free\":5496320039968,\"max\":5497558138880,\"used\":1238098912,\"showing\":\"lifetime\"},\"periodic\":{\"free\":null,\"max\":null,\"used\":null,\"reset_date\":null},\"lifetime\":{\"free\":5496320039968,\"max\":5497558138880,\"used\":1238098912}},\"resource_key\":\"59de563e2d9365b22514ebc53bdcc79bd18ed11d\",\"account\":\"business\"},\"parent_folder\":null,\"last_user_action_event_date\":\"2021-01-15T05:34:27+00:00\",\"review_page\":{\"active\":true,\"link\":\"https://vimeo.com/user104937606/review/500729601/3b99acfbed\"},\"files\":[],\"download\":[],\"app\":{\"name\":\"AI Talking English\",\"uri\":\"/apps/159657\"},\"status\":\"uploading\",\"resource_key\":\"1fd0f3744b196efc6ef33c9ef9e66e5e0fad2877\",\"upload\":{\"status\":\"in_progress\",\"upload_link\":\"https://asia-files.tus.vimeo.com/files/vimeo-prod-src-tus-asia/3df821a4fd8800864268c12ae5817658\",\"form\":null,\"complete_uri\":null,\"approach\":\"tus\",\"size\":678563,\"redirect_url\":null,\"link\":null},\"transcode\":{\"status\":\"in_progress\"},\"is_playable\":false}","__typename":"Videos"},"idate":"2021-01-15T14:34:29.000Z","__typename":"Files"},"test_answers":[{"idx":283,"code":"1","answer":"2","option_count":5,"pdf":{"idx":59,"name":"Awesome_Monthly Test_Level6_Vol1_Answer_Key_032819.pdf","path":"https://cdn.cloubot.com/class-boom/59f738cc-c634-4c30-8138-193ab7bd6fc1Awesome_Monthly Test_Level6_Vol1_Answer_Key_032819.pdf","mime_type":"application/pdf","encoding":"7bit","is_public":false,"storage_type":1,"folders":{"idx":8,"name":"Awesome","idate":"2021-01-05T16:43:36.000Z","user":{"idx":1000002,"name":"Test Campus","__typename":"User"},"__typename":"Folders"},"user":{"idx":1000002,"name":"Test Campus","__typename":"User"},"videos":null,"idate":"2021-01-05T16:58:39.000Z","__typename":"Files"},"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":284,"code":"2","answer":"3","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":285,"code":"3","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":286,"code":"4","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":287,"code":"5","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":288,"code":"6","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":289,"code":"7","answer":"4","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":290,"code":"8","answer":"3","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":291,"code":"9","answer":"2","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":292,"code":"10","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"}],"__typename":"Tests"},"__typename":"AssignedTests"},"assigned_test_answers":[],"user":{"idx":1000004,"name":"Test Student","__typename":"User"},"__typename":"AssignedTestUsers"}}}

export const singleTestResult = {"data":{"assignedTestUserSingle":{"idx":27,"status":2,"score":"60%","idate":null,"start_time":"2021-01-14T17:09:50.000Z","end_time":"2021-01-14T17:12:52.000Z","assigned_tests":{"idx":16,"title":"1234","start_time":"2021-01-13T12:07:19.000Z","limit_time":60,"tests":{"idx":63,"title":"새테스트002","code":"T-2101031701","main_pdf":{"path":"https://cdn.cloubot.com/class-boom/4eaf7bbb-6c2f-407e-b2d2-d4e64e450d21[5회]KNN수학창의력대회 선다형서술형문제(초등4학년).pdf","name":"[5회]KNN수학창의력대회 선다형서술형문제(초등4학년).pdf","__typename":"Files"},"extra_pdf":null,"extra_audio":null,"extra_video":null,"test_answers":[{"idx":41,"code":"1","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":42,"code":"2","answer":"2","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":43,"code":"3","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":44,"code":"4","answer":"2","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":45,"code":"5","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":46,"code":"6","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":47,"code":"7","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":48,"code":"8","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":49,"code":"9","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"},{"idx":50,"code":"10","answer":"1","option_count":5,"pdf":null,"audio":null,"video":null,"__typename":"TestAnswers"}],"__typename":"Tests"},"__typename":"AssignedTests"},"assigned_test_answers":[{"idx":21,"answer":"1","is_correct":true,"code":"1","__typename":"AssignedTestAnswers"},{"idx":22,"answer":"1","is_correct":false,"code":"2","__typename":"AssignedTestAnswers"},{"idx":23,"answer":"1","is_correct":true,"code":"3","__typename":"AssignedTestAnswers"},{"idx":24,"answer":"1","is_correct":false,"code":"4","__typename":"AssignedTestAnswers"},{"idx":25,"answer":"1","is_correct":true,"code":"5","__typename":"AssignedTestAnswers"},{"idx":26,"answer":"1","is_correct":true,"code":"6","__typename":"AssignedTestAnswers"},{"idx":27,"answer":"1","is_correct":false,"code":"7","__typename":"AssignedTestAnswers"},{"idx":28,"answer":"1","is_correct":true,"code":"8","__typename":"AssignedTestAnswers"},{"idx":29,"answer":"1","is_correct":false,"code":"9","__typename":"AssignedTestAnswers"},{"idx":30,"answer":"1","is_correct":true,"code":"10","__typename":"AssignedTestAnswers"}],"user":{"idx":1000004,"name":"Test Student","__typename":"User"},"__typename":"AssignedTestUsers"}}}


export const levelTestList = {"data":{"assignedTestsSingle":{"idx":5,"title":"새테스트002","idate":"2020-12-18T17:20:23.000Z","start_time":"2020-12-30T00:04:00.000Z","done":1,"class":{"idx":1,"__typename":"Class"},"tests":{"idx":11,"title":"새테스트002","code":"T-2012181712","test_answers":[{"idx":27,"code":"1","answer":"1","__typename":"TestAnswers"},{"idx":28,"code":"2","answer":"2","__typename":"TestAnswers"},{"idx":29,"code":"3","answer":"3","__typename":"TestAnswers"},{"idx":30,"code":"4","answer":"a1","__typename":"TestAnswers"},{"idx":31,"code":"5","answer":"a2,b1","__typename":"TestAnswers"}],"__typename":"Tests"},"user":{"idx":1000003,"name":"Test Teacher","__typename":"User"},"assigned_test_users":[{"idx":9,"score":3,"start_time":"2020-12-18T17:21:07.000Z","end_time":"2020-12-18T17:21:10.000Z","user":{"idx":1000004,"name":"Test Student","__typename":"User"},"assigned_test_answers":[{"idx":6,"answer":"2","is_correct":false,"code":"1","__typename":"AssignedTestAnswers"},{"idx":7,"answer":"3","is_correct":true,"code":"3","__typename":"AssignedTestAnswers"},{"idx":8,"answer":"a1","is_correct":true,"code":"4","__typename":"AssignedTestAnswers"},{"idx":9,"answer":"a1,a2","is_correct":false,"code":"5","__typename":"AssignedTestAnswers"},{"idx":10,"answer":"2","is_correct":true,"code":"2","__typename":"AssignedTestAnswers"}],"__typename":"AssignedTestUsers"},{"idx":10,"score":null,"start_time":null,"end_time":null,"user":{"idx":1000007,"name":"user 2","__typename":"User"},"assigned_test_answers":[],"__typename":"AssignedTestUsers"}],"__typename":"AssignedTests"}}}


export const score = [
  {
    name: '홍길동',
    1: '0',
    2: '0',
    3: '0',
    4: '0',
    5: '0',
    6: '0',
    7: '0',
    8: '0',
    9: 'x',
    10: '0',
    11: '0',
    12: '0',
    13: '0',
    14: '0',
    15: 'x',
    16: '0',
    17: '0',
    18: '0',
    19: '0',
    20: '0',
    21: '0',
    22: '0',
    23: '0',
    24: '0',
    25: '0',
    26: '0',
    time: '00:40:00',
    score: '80'
  },
  {
    name: '김은미',
    1: '0',
    2: '0',
    3: '0',
    4: '0',
    5: '0',
    6: '0',
    7: '0',
    8: '0',
    9: '0',
    10: 'x',
    11: '0',
    12: '0',
    13: '0',
    14: '0',
    15: '0',
    16: 'x',
    17: '0',
    18: '0',
    19: '0',
    20: '0',
    21: '0',
    22: '0',
    23: '0',
    24: '0',
    25: '0',
    26: '0',
    time: '00:40:00',
    score: '80'
  },
  {
    name: '김일준',
    1: '0',
    2: '0',
    3: '0',
    4: '0',
    5: '0',
    6: '0',
    7: 'x',
    8: '0',
    9: '0',
    10: '0',
    11: '0',
    12: '0',
    13: '0',
    14: '0',
    15: '0',
    16: '0',
    17: '0',
    18: '0',
    19: '0',
    20: '0',
    21: '0',
    22: '0',
    23: '0',
    24: '0',
    25: '0',
    26: '0',
    time: '00:40:00',
    score: '80'
  },
  {
    name: '이선희',
    1: '0',
    2: '0',
    3: '0',
    4: '0',
    5: '0',
    6: '0',
    7: 'x',
    8: '0',
    9: '0',
    10: '0',
    11: '0',
    12: '0',
    13: '0',
    14: '0',
    15: '0',
    16: '0',
    17: '0',
    18: '0',
    19: '0',
    20: '0',
    21: '0',
    22: '0',
    23: '0',
    24: '0',
    25: '0',
    26: '0',
    time: '00:40:00',
    score: '80'
  },
  {
    name: '홍길동',
    1: '0',
    2: '0',
    3: '0',
    4: '0',
    5: '0',
    6: '0',
    7: '0',
    8: '0',
    9: '0',
    10: 'x',
    11: '0',
    12: '0',
    13: '0',
    14: '0',
    15: '0',
    16: '0',
    17: '0',
    18: '0',
    19: 'x',
    20: '0',
    21: '0',
    22: '0',
    23: '0',
    24: '0',
    25: '0',
    26: '0',
    time: '00:40:00',
    score: '90'
  },
  {
    name: '',
    1: '90',
    2: '80',
    3: '90',
    4: '80',
    5: '90',
    6: '90',
    7: '70',
    8: '89',
    9: '90',
    10: '80',
    11: '91',
    12: '78',
    13: '89',
    14: '78',
    15: '78',
    16: '80',
    17: '78',
    18: '90',
    19: '80',
    20: '80',
    21: '80',
    22: '90',
    23: '90',
    24: '80',
    25: '90',
    26: '90',
    time: '00:40:00',
    score: '평균 85'
  }
];
